module.exports = __webpack_public_path__ + "img/0040030-PS2.fa2896fe.jpg";